import { sortList } from "../../companies/enum/company";

//  Vendors Branches Tab
export enum VendorBranchesSortList {
    department_name = "department_name",
    created_at = 'created_at'
}
export class VendorBranchesListData {
    data!: {
        total: number;
        list: {
            id: any
            num_withdraw_points: string
            num_employee: string
            created_at: string
        }[];
    }
}
export class VendorBranchesListFilter {
    page: number = 0
    perPage: number = 10
    vendor_id!: any
    city_id!: any
    sort: sortList = sortList.DESC;
    sortBy: "branch_name" | 'created_at' = "branch_name"
    search!: string
}

export interface VendorBranche {
    city_name: string
    branch_name: string
    branch_address: string
    name_en: string
    name_ar: string
    address_ar: string
    address_en: string
    map_lat: string
    map_lang: string
    created_at: string
}